import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'sume-new-card-buttons',
    templateUrl: './new-card-buttons.component.html',
    styleUrls: ['./new-card-buttons.component.scss'],
})
export class NewCardButtonsComponent {
    @Input() textoCancelar: string = 'Cancelar';
    @Input() textoConfirmar: string = 'Confirmar';
    @Input() canSubmit: boolean = true;
    @Input() disabledMessage: string = '';

    @Output() cancelar = new EventEmitter<void>();
    @Output() confirmar = new EventEmitter<void>();

    onCancelar(): void {
        this.cancelar.emit();
    }

    onConfirmar(): void {
        this.confirmar.emit();
    }
}
